














































import { Vue } from 'vue-property-decorator';
import { Component, Mixin, Mixins } from 'vue-mixin-decorator';
import { vxm } from '@/store';
import PortfolioSection from '@/components/PortfolioSection.vue';
import Profile from '@/components/Profile.vue';
import Project from '@/components/Project.vue';
import PortfolioFooter from '@/components/PortfolioFooter.vue';
import Projects from '@/components/Projects.vue';
import GithubData from '@/services/github-data';
import { GithubRepo } from '@/models/github-repo';
import { GithubUser } from '@/models/github-user';

@Component({
  components: {
    PortfolioSection,
    Profile,
    Project,
    Projects,
    PortfolioFooter,
  },
})
export default class Home extends Vue {
  private get User() {
    return vxm.user.gitUser;
  }

  private get Sections() {
    return vxm.repo.sections;
  }

  private get Config() {
    return vxm.config.cfg;
  }

  private async mounted() {
    await vxm.config.loadConfig();
    // This shouldn't be called until the config has been loaded
    vxm.user.loadUser(vxm.config.cfg);
    vxm.repo.loadRepos(vxm.config.cfg);
  }
}
